module.exports = __webpack_public_path__ + "static/media/blog_img2.56324905.png";